const postToTeams = (url, body) => {
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).catch((error) => {
    // eslint-disable-next-line no-console
    console.error(error);
  });
};

// Teams User Message
/**
 * Submit user message to Teams
 * @param {object} body - Message body
 */
export const SubmitTeamsUserMsg = (body) => {
  const apiVersion = '2020-05-01-preview';
  const sp = '%2Ftriggers%2Fmanual%2Frun';
  const sv = '1.0';
  const sig = 't58e9nwmYASTftlw8fafVzeR4_0SRWLv4iAjtEA59ng';
  postToTeams(
    `https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsChat/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};

/**
 * Submit user message to Teams CWS
 * @param {object} body - Message body
 */
export const SubmitTeamsUserMsgCWS = (body) => {
  const apiVersion = '2020-05-01-preview';
  const sp = '%2Ftriggers%2Fmanual%2Frun';
  const sv = '1.0';
  const sig = 't58e9nwmYASTftlw8fafVzeR4_0SRWLv4iAjtEA59ng';
  postToTeams(
    `https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsChat/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};

/**
 * Submit user message to Teams Avanti
 * @param {object} body - Message body
 */
export const SubmitTeamsUserMsgAvanti = (body) => {
  const apiVersion = '2022-05-01';
  const sp = '%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun';
  const sv = '1.0';
  const sig = 'nyJnvCTXl4HWuvmUfS4oW3VpWiSjgXD5SN2Un25VJVg';
  postToTeams(
    `https://thrive.azurewebsites.net/api/TeamsChat/triggers/When_a_HTTP_request_is_received/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};

// Teams Channel Message
/**
 * Submit channel message to Teams
 * @param {object} body - Message body
 */
export const SubmitTeamsChannelMsg = (body) => {
  const apiVersion = '2020-05-01-preview';
  const sp = '%2Ftriggers%2Fmanual%2Frun';
  const sv = '1.0';
  const sig = 'H6g8CugT_NbHMiplBk0FddNRO_AHFRrimbcqWHQmMso';
  postToTeams(
    `https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsChannel/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};

/**
 * Submit channel message to Teams CWS
 * @param {object} body - Message body
 */
export const SubmitTeamsChannelMsgCWS = (body) => {
  const apiVersion = '2020-05-01-preview';
  const sp = '%2Ftriggers%2Fmanual%2Frun';
  const sv = '1.0';
  const sig = 'H6g8CugT_NbHMiplBk0FddNRO_AHFRrimbcqWHQmMso';
  postToTeams(
    `https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsChannel/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};

/**
 * Submit channel message to Teams Avanti
 * @param {object} body - Message body
 */
export const SubmitTeamsChannelMsgAvanti = (body) => {
  const apiVersion = '2022-05-01';
  const sp = '%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun';
  const sv = '1.0';
  const sig = 'qEv63et0tCFaDvTs5uJNDxnF2IABcQbuRavj922NhLw';
  postToTeams(
    `https://thrive.azurewebsites.net/api/TeamsChannel/triggers/When_a_HTTP_request_is_received/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};

// Team User Card
/**
 * Submit user card to Teams
 * @param {object} body - Card body
 */
export const SubmitTeamsUserCard = (body) => {
  const apiVersion = '2020-05-01-preview';
  const sp = '%2Ftriggers%2Fmanual%2Frun';
  const sv = '1.0';
  const sig = 'QmT_uLx_gg9NRTn-9DAZVpYpnxYhGOfSd52RSXAO4u4';
  postToTeams(
    `https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsCardChat/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};

/**
 * Submit user card to Teams CWS
 * @param {object} body - Card body
 */
export const SubmitTeamsUserCardCWS = (body) => {
  const apiVersion = '2020-05-01-preview';
  const sp = '%2Ftriggers%2Fmanual%2Frun';
  const sv = '1.0';
  const sig = 'QmT_uLx_gg9NRTn-9DAZVpYpnxYhGOfSd52RSXAO4u4';
  postToTeams(
    `https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsCardChat/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};

/**
 * Submit user card to Teams Avanti
 * @param {object} body - Card body
 */
export const SubmitTeamsUserCardAvanti = (body) => {
  const apiVersion = '2022-05-01';
  const sp = '%2Ftriggers%2FWhen_a_HTTP_request_is_received';
  const sv = '1.0';
  const sig = '7bn9v2akjdUO2yihZtGX-teCEbo_tJza7Y3qcviz-M8';
  postToTeams(
    `https://thrive.azurewebsites.net/api/TeamsCardChat/triggers/When_a_HTTP_request_is_received/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};

// Team Channel Card
/**
 * Submit channel card to Teams
 * @param {object} body - Card body
 */
export const SubmitTeamsChannelCard = (body) => {
  const apiVersion = '2020-05-01-preview';
  const sp = '%2Ftriggers%2Fmanual%2Frun';
  const sv = '1.0';
  const sig = 'MoS_ScSFCHp_qXoY6-GdLfQ1MNcj2X32ebriyH2Z0KE';
  postToTeams(
    `https://cus-mfg-teams-prod-la.azurewebsites.net:443/api/dataManager2TeamsCardChannel/triggers/manual/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};

/**
 * Submit channel card to Teams CWS
 * @param {object} body - Card body
 */
export const SubmitTeamsChannelCardCWS = (body) => {
  const apiVersion = '2016-06-01';
  const sp = '%2Ftriggers%2Fmanual%2Frun';
  const sv = '1.0';
  const sig = '8dH5t2a1l3rdxHMwc3b471TEE_rG7ypLrDrvvRJUlRk';
  postToTeams(
    `https://prod-48.westus.logic.azure.com:443/workflows/e7063009e5094c379383aa8f171e3f0d/triggers/manual/paths/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};

/**
 * Submit channel card to Teams Avanti
 * @param {object} body - Card body
 */
export const SubmitTeamsChannelCardAvanti = (body) => {
  const apiVersion = '2022-05-01';
  const sp = '%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun';
  const sv = '1.0';
  const sig = 'x2WCWUg7Nb6Zp0lUJha7ZiNl9aXAtHg3P096FmMujEo';
  postToTeams(
    `https://thrive.azurewebsites.net/api/TeamsCardChannel/triggers/When_a_HTTP_request_is_received/invoke?api-version=${apiVersion}&sp=${sp}&sv=${sv}&sig=${sig}`,
    body,
  );
};
